import { Prize, PrizeStore } from '@stores/prize.store';
import apiResponse from '@stores/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { ViewCreatorStaleTime } from '@utils/queryCacheConfig';

export type PrizeView = {
  id: number;
  message: string;
  link: string;
  amount: number | null;
  receivedOn: string | null;
};

export class PrizesViewCreator {
  constructor(private readonly store: PrizeStore = new PrizeStore()) {}

  async createView(cohortUserId: number): Promise<PrizeView[]> {
    const prizes = await apiResponse.handleApiResponse<Prize[]>(async () => await this.store.getPrizes(cohortUserId));

    return (prizes || []).map((prize) => ({
      id: prize.id,
      message: prize.message ?? '',
      link: prize.link ?? '',
      amount: prize.amount === null || prize.amount === undefined ? null : Number(prize.amount),
      receivedOn: prize.createdAt ?? null,
    }));
  }
}

export const usePrizesViewCreator = (cohortUserId: number) =>
  useQuery({
    queryKey: [PrizesViewCreator.name, cohortUserId],
    queryFn: () => new PrizesViewCreator().createView(cohortUserId),
    staleTime: ViewCreatorStaleTime.PrizesViewCreator,
    enabled: cohortUserId > 0,
  });
